import { useEffect, useState } from "react";

import OperatorList from "./formulation-tab/OperatorList";

import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";
import CustomButton from "../kits/button/CustomButton";
import { PlusIcon, ArrowLeftIcon1 } from "../kits/Icons";
import ToastCustomize from "../kits/ToastCustomize";

export default function MakeMathematicalString({
  mathPreview,
  setMathPreview,
  enterFormul,
  setEnterFormul,
  formulationList,
  setFormulationList,
  hasLimit,
  limitCount,
  compareOperator = false,
  firstOperator,
  setFirstOperator,
  addToPreview,
  attributeProductList,
  chooseMainProperty = false,
  attributeBaseOnProduct,
}) {
  const [deactivateItems, setDeactivateItems] = useState(false);
  const [operatorList, setOperatorList] = useState([
    "+",
    "-",
    "*",
    "/",
    "=",
    ">",
    ">=",
    "<",
    "<=",
  ]);
  const [propertyId, setPropertyId] = useState("-1");
  const addFormulationToList = (itemFormulation, itemPreview) => {
    let formulationListTemp = formulationList;
    formulationListTemp.push({
      formulationList: itemFormulation,
      mathPreview: itemPreview,
      made_product_property_id: propertyId?.value,
      made_product_property_title: propertyId?.label,
    });

    if (hasLimit && formulationListTemp.length == limitCount)
      setDeactivateItems(true);
    else setDeactivateItems(false);
    setFormulationList(formulationListTemp);
  };

  const popOneByOne = () => {
    let tempEnterFormul = enterFormul;
    if (!compareOperator || tempEnterFormul.length > 1) {
      tempEnterFormul.pop();
      setEnterFormul(tempEnterFormul);
      let tempMathPreview = "";
      if (enterFormul.length == 0 && compareOperator == false)
        setFirstOperator(true);
      tempMathPreview = tempEnterFormul
        .map((v) => v.name)
        .toString()
        .replaceAll(",", " ");

      setMathPreview(tempMathPreview);
    }
  };
  const checkAndAddFormul = (item) => {
    let lastItem = item[item.length - 1];
    if (
      (chooseMainProperty && propertyId != -1) ||
      chooseMainProperty == false
    ) {
      if (lastItem.type == "operator") {
        ToastCustomize({
          mainText: (
            <span style={{ lineHeight: 1.5 }}>
              فرمول وارد شده صحیح نیست، در انتهای فرمول نباید عملگر قرار بگیرد.
            </span>
          ),
          duration: 3000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        addFormulationToList(item, mathPreview);
        setEnterFormul([]);
        setMathPreview("");
        setFirstOperator(true);
        setPropertyId(-1);
      }
    } else {
      ToastCustomize({
        mainText: (
          <span style={{ lineHeight: 1.5 }}>صفت اصلی را انتخاب کنید.</span>
        ),
        duration: 3000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    }
  };

  useEffect(() => {
    if (compareOperator) {
      setOperatorList(["+", "-", "*", "/"]);
      setFirstOperator(false);
      addToPreview("=", "operator");
    } else {
      setOperatorList(["+", "-", "*", "/", "=", ">", ">=", "<", "<="]);
      setFirstOperator(true);
    }
  }, [compareOperator]);
  useEffect(() => {
    let formulationListTemp = formulationList;

    if (hasLimit && formulationListTemp.length == limitCount)
      setDeactivateItems(true);
    else setDeactivateItems(false);
  }, [formulationList]);

  return (
    <div className="">
      <div
        className="border border-bottom-0  w-100 mx-auto"
        style={{
          bottom: 120,
          right: 0,
          paddingBottom: 30,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          fontSize: 13,
        }}
      >
        <p className="p-2" style={{ fontWeight: "bold" }}>
          انتخاب عملگر و متغیر
        </p>
        <OperatorList
          arrayOperator={operatorList}
          addToPreview={addToPreview}
          firstOperator={firstOperator}
          deactivateItems={deactivateItems}
          attributeProductList={attributeProductList}
          chooseMainProperty={chooseMainProperty}
          setPropertyId={setPropertyId}
          propertyId={propertyId}
          attributeBaseOnProduct={attributeBaseOnProduct}
        />
      </div>
      <div
        className="  d-flex math-preview-container "
        style={{ top: "-20px" }}
      >
        <div className="d-flex align-items-center me-2">
          <button
            className="bg-secondary mx-1 rounded p-1"
            onClick={() => popOneByOne()}
          >
            <ArrowLeftIcon1 color="white" style={{ width: 15, height: 15 }} />
          </button>
        </div>

        <CustomInput
          label=""
          inputSize="text"
          type="text"
          inputContainer="math-preview flex-grow-1"
          inputClassName="form-input"
          inputValue={mathPreview}
          activate="readOnly"
          // textErr={validationTxt.answers}
        />
        <div className="d-flex align-items-center ms-2" style={{}}>
          <CustomButton
            color="success"
            size="small"
            state={deactivateItems ? "deactive" : "active"}
            circle={true}
            onClick={() => checkAndAddFormul(enterFormul)}
            style={{ opacity: deactivateItems && "0.4" }}
          >
            <PlusIcon color="white" /> افزودن
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
